import { Container } from '@acies/core';
import Label from './label';
import theme from './theme';

export default class Badge extends Container {
	public static override observedAttributes: string[] = [...Container.observedAttributes, 'text'];
	public set text(value: string) {
		this.#textLabel.text = value;
	}

	public get text(): string {
		return this.#textLabel.text;
	}

	#textLabel: Label;
	public constructor() {
		super();
		this.alignment = 'center';
		this.cornerRadius = 10;
		this.fill = theme.colors.fill.soft;
		this.height = 20;
		this.minWidth = 40;
		this.paddingHorizontal = 12;
		this.#textLabel = new Label();
		this.#textLabel.size = 'xsmall';
	}

	protected override attributeChangedCallback(name: string, _: string, value: string) {
		super.attributeChangedCallback(name, _, value);
		if (name === 'text') {
			this.#textAttributeChanged(value);
		}
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponent(this.#textLabel);
	}

	#textAttributeChanged(value: string): void {
		this.text = value;
	}
}
customElements.define('ac-badge', Badge);
